var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-wrapper"},[_c('div',{staticClass:"text"},_vm._l((_vm.word),function(letter,index){return _c('span',{key:index,staticClass:"letter mx-1",class:{ poofed: !letter.alive },on:{"click":function($event){return _vm.rem(index)}}},[_c('div',{staticClass:"character"},[_vm._v(_vm._s(letter.char))]),_c('span')])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }